import sidebar from "routes/sidebar";
import { privilegeMatches } from "utils/privileges";

/** Routes anyone logged-in can open (no specific privilege). */
export const OPEN_ROUTE_PATHS = [
  "/dashboard",
  "/edit-profile",
  "/404",
  "/coming-soon",
];

/**
 * Build path → required privilege slugs from sidebar + detail pages.
 */
export const buildRoutePrivilegeMap = () => {
  const map = {};

  const add = (path, previleges) => {
    if (!path || !previleges?.length) return;
    map[path] = previleges;
  };

  sidebar.forEach((item) => {
    add(item.path, item.previleges);
    (item.routes || []).forEach((child) => {
      add(child.path, child.previleges || item.previleges);
    });
  });

  // Detail / nested pages (same rights as parent list)
  const aliases = {
    "/blog/:id": "/blogs",
    "/project/:id": "/projects",
    "/service/:id": "/services",
    "/career/:id": "/careers",
    "/reference/:id": "/references",
    "/slider/:id": "/sliders",
    "/contact/:id": "/contacts",
    "/contacts/:iddep": "/contacts",
    "/quote/:id": "/quotes",
    "/quotes-management/:id": "/quotes-management",
    "/quotes-management/update/:id": "/quotes-management",
    "/add-quote": "/quotes",
    "/department/:id": "/departments",
    "/categories/:id": "/categories",
    "/admin/:id/previleges": "/our-staff",
  };

  Object.entries(aliases).forEach(([detailPath, parentPath]) => {
    if (map[parentPath]) {
      map[detailPath] = map[parentPath];
    }
  });

  return map;
};

export const ROUTE_PRIVILEGES = buildRoutePrivilegeMap();

/** Find required privileges for a route definition path (may include :params). */
export const getRequiredPrivilegesForPath = (routePath) => {
  if (!routePath || OPEN_ROUTE_PATHS.includes(routePath)) return null;
  return ROUTE_PRIVILEGES[routePath] || null;
};

/** True if user may open this route path pattern. */
export const canAccessRoute = (routePath, userSlugs = []) => {
  const required = getRequiredPrivilegesForPath(routePath);
  if (!required) return true;
  return required.some((slug) => privilegeMatches(userSlugs, slug));
};
